import React, { useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import { useLocation, useParams } from "react-router-dom";
import { usePostgresViewer } from "components/viewer/context";
import Form from "pages/eligibility/components/context/form-data";

import { LoginModal } from "components/login";
import { getLayout, getSectionIndex } from "../helpers";
import FormLayout from "./form-layout";

type Props = {
  path?: string;
  section?: string;
}

const LoginPortal: React.FC<{isSignup?: boolean}> = ({ isSignup = false }) => {
  const element = document.querySelector("#login-modal") as Element | null;
  const target = element || document.body;
  return ReactDOM.createPortal(<LoginModal isSignup={isSignup}/>, target);
};

const AuthenticatedForm: React.FC<Props> = (props) => {
  const formData = React.useContext(Form);
  const viewer = usePostgresViewer();

  if (!formData) return null;
  const layout = getLayout(formData);
  const location = useLocation();
  const {
    section: sectionParam,
    submissionId: submissionParam,
  } = useParams<{ section?: string; submissionId?: string }>();

  const effectiveSection = props.section || sectionParam;
  const sectionIndex = getSectionIndex(effectiveSection, layout);

  const [isSignup, setIsSignUp] = React.useState(false);
  const [isLogin, setIsLogin] = React.useState(false);

  useLayoutEffect(
    () => {
      const query = new URLSearchParams(window.location.search);
      const signup = query.get("is-signup");
      const login = query.get("is-login");

      setIsSignUp(signup === "true");
      setIsLogin(login === "true");
    }
    , [window.location.search],
  );


  // Resolve submissionId only when using the /application prefix
  const segments = location.pathname.split("/").filter(Boolean);
  const submissionFromPath = segments[0] === "application" && segments.length >= 2 ? segments[1] : "";
  const effectiveSubmissionId = submissionParam || submissionFromPath;
  const path = { match: { submissionId: effectiveSubmissionId } };
  const showLoginForApplicationLink = viewer === null && effectiveSubmissionId !== "";
  const showLoginAfterFirstSection = viewer === null && sectionIndex >= 1;
  return (
    <>
      <FormLayout form={formData} section={effectiveSection || ""} path={path} />
      {((showLoginForApplicationLink || showLoginAfterFirstSection) || isSignup || isLogin) && (
        <LoginPortal isSignup={isSignup} />)}
    </>
  );
};

export default AuthenticatedForm;
